import { UserInterface } from 'modules/auth/interfaces/user';
import environment from '@/environment';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '@/store';

const router = new VueRouter({
  mode: 'hash',
  routes,
});

const allowedStates = [
  'login',
  'register',
  'logout',
  'reset-password',
  'set-new-password',
  'installation-wizard',
  'select-account',
  'shoper',
  'redirect-from-mobile',
  'redirect-to-integration'
];

router.beforeEach((to, from, next) => {
  console.log('Before Transition from ' + from.name + ' to ' + to.name);

  let nextRoute: string | undefined;

  const userJson: string | null = environment.userLocalStorageKey ?
    localStorage.getItem(environment.userLocalStorageKey) : null;
  let user: UserInterface | null;

  if (userJson) {
    user = JSON.parse(userJson);
    store.commit('auth/updateUser', user);
  }

  if (store.state && store.state.auth && store.state.auth.user && store.state.auth.user.access_token) {
    if (to && to.name === 'login') {
      nextRoute = '/';
    }
  } else {
    if (to && to.name && allowedStates.indexOf(to.name) === -1) {
      nextRoute = 'login';
    }
  }

  next(nextRoute);
});

router.afterEach((to, from) => {
  console.log('Successfull Transition from ' + from.name + ' to ' + to.name);
});

export default router;
